
const getFields = <T>(object :any, fields :string[]) :T[] => {
    return fields.map((key :string) => object[key]).filter((val :T) => !!val)
}

const UtilObject = {
    getFields
}

export default UtilObject